<app-modal>
  <div class="modal-m">
    <app-modal-content class="p15 d-block">
      <h4>{{ 'general.mobile_app_removal.title_l' | translate }}</h4>
      <p>{{ 'general.mobile_app_removal.description_l' | translate }}</p>
      <button im-button class="primary mt5" (click)="openStore()">
        {{ 'general.mobile_app_removal.browser_url_l' | translate }}
      </button>
    </app-modal-content>
    @if (isStillValid()) {
      <app-modal-footer>
        <div class="modal-footer">
          <button im-button class="primary" (click)="close()">
            {{ 'general.ok' | translate }}
          </button>
        </div>
      </app-modal-footer>
    }
  </div>
</app-modal>
